import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

import { EventFactory } from 'app/factories';
import { Usergroup_Role_Type_Enum } from 'app/graphql/generated/graphql-types';
import { mergeRouteParams } from 'app/helpers';
import { EventProfileState } from 'app/services';

export const eventProfileRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const eventFactory = inject(EventFactory);
    const eventProfileState = inject(EventProfileState);

    const params = mergeRouteParams(route);

    if (!params.eventId) {
        router.navigate(['/']);
        return false;
    }

    const canAccess: ReplaySubject<boolean> = new ReplaySubject(1);

    if (
        route.data &&
        route.data['allowedRoles'] &&
        route.data['allowedRoles'].indexOf(Usergroup_Role_Type_Enum.guest) === -1
    ) {
        eventFactory
            .getEvent({ eventId: params.eventId })
            .pipe(first())
            .subscribe({
                next: ({ data }) => {
                    if (data.event.merole && route.data['allowedRoles'].indexOf(data.event.merole) !== -1) {
                        eventProfileState.setIsAdminProfile(!!route.data['adminProfile']);
                        canAccess.next(true);
                    } else {
                        router.navigate(['/event', params.eventId]);
                        canAccess.next(false);
                    }
                },
                error: () => {
                    router.navigate(['/']);
                    canAccess.next(false);
                },
            });
    } else {
        eventProfileState.setIsAdminProfile(false);
        canAccess.next(true);
    }
    return canAccess;
};
